import Vue from "vue";
import VueRouter from "vue-router";
import auth from '../utils/auth.js'

Vue.use(VueRouter);

let base = process.env.NODE_ENV !== 'production' ? '' : '/meeting/m/';
let forceHttps = process.env.NODE_ENV === 'production';

const routes = [
  {
    path: '/home',
    name: 'home',
    component: resolve => require(['@/views/index.vue'], resolve),
    redirect: {name: 'book'},
    children: [
      {
        path: 'wechat/:type/redirect/:companyId',
        name: 'wechatRedirect',
        component: resolve => require(['@/views/wechat/redirect.vue'], resolve),
        meta: {hideTab: true}
      },
      {
        path: 'book',
        name: 'book',
        component: resolve => require(['@/views/book/index.vue'], resolve),
        meta: {index: 0, requiresAuth: true}
      },
      {
        path: 'meeting',
        name: 'meeting',
        component: resolve => require(['@/views/meeting/index.vue'], resolve),
        meta: {index: 0, requiresAuth: true}
      },
      {
        path: 'signIn',
        name: 'signIn',
        component: resolve => require(['@/views/signIn/index.vue'], resolve),
        meta: {index: 0, requiresAuth: true}
      },
      {
        path: 'mine',
        name: 'mine',
        component: resolve => require(['@/views/mine/index.vue'], resolve),
        meta: {index: 0, requiresAuth: true}
      },
      {
        path: 'addMeeting',
        name: 'addMeeting',
        component: resolve => require(['@/views/book/meeting.vue'], resolve),
        meta: {index: 1, requiresAuth: true}
      },
      {
        path: 'editMeeting',
        name: 'editMeeting',
        component: resolve => require(['@/views/meeting/edit.vue'], resolve),
        meta: {index: 1, requiresAuth: true}
      },
      {
        path: 'auditMeeting',
        name: 'auditMeeting',
        component: resolve => require(['@/views/meeting/audit.vue'], resolve),
        meta: {index: 3,tab:'mine', requiresAuth: true}
      },
      {
        path: 'signInDetail',
        name: 'signInDetail',
        component: resolve => require(['@/views/signIn/detail.vue'], resolve),
        meta: {index: 1, hideTab: true,requiresAuth: true}
      },
      {
        path: 'trtc',
        name: 'trtc',
        component: resolve => require(['@/views/mine/trtc/index.vue'], resolve),
        meta: {index: 1, hideTab: true, requiresAuth: true}
      }
      ,
      {
        path: 'inOut',
        name: 'inOut',
        component: resolve => require(['@/views/mine/inOut/index.vue'], resolve),
        meta: {index: 1, hideTab: true, requiresAuth: true}
      },
      {
        path: 'todo',
        name: 'todo',
        component: resolve => require(['@/views/meeting/todo.vue'], resolve),
        meta: {index: 3,tab:'mine',  requiresAuth: true}
      },
      {
        path: 'password/update/:userId',
        name: 'updatePassword',
        component: resolve => require(['@/views/mine/password/update.vue'], resolve)
      },
    ]
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/views/login/index.vue'], resolve)
  },
  {
    path: '/quick/login/:s',
    name: 'quickLogin',
    component: resolve => require(['@/views/login/quick.vue'], resolve),
  },
  {
    path: '/sign',
    name: 'sign',
    component: resolve => require(['@/views/signIn/sign.vue'], resolve)
  },

  {
    path: '/ats/:userId',
    name: 'affiliatedTerminals',
    component: resolve => require(['@/views/mine/terminals/index.vue'], resolve)
  },

];

const router = new VueRouter({
  mode: "history",
  base: base,
  routes
});


router.beforeResolve((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    auth.loggedIn().then(function () {
      next()
    }).catch(function (err) {
      if (err&&err.code == 41000) {
        window.location.href =`${app.$prefix}home/password/update/${err.value}`
      }else
      {
        window.location.href =`${app.$prefix}login`
      }
      next()
    })
  } else {
    next() // 确保一定要调用 next()
  }
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js